import React, { useState, useEffect, useRef } from 'react';

const BottomNav = ({ showPage, activePage, isAuthenticated, userRole }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleServiceClick = (page) => {
        showPage(page);
        setIsMenuOpen(false);
    };

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-2 px-3 flex justify-between items-center z-50 shadow-[0_-4px_10px_rgba(0,0,0,0.05)]">
            <button 
                onClick={() => showPage('landing')}
                className={`flex flex-col items-center gap-1 ${activePage === 'landing' ? 'text-sky-600 scale-110 transition-transform' : 'text-sky-400 hover:text-sky-500'}`}
            >
                <i className="fas fa-home text-lg"></i>
                <span className="text-[10px] font-bold">Home</span>
            </button>
            
            <button 
                onClick={() => showPage('products')}
                className={`flex flex-col items-center gap-1 ${activePage === 'products' ? 'text-indigo-600 scale-110 transition-transform' : 'text-indigo-400 hover:text-indigo-500'}`}
            >
                <i className="fas fa-th-large text-lg"></i>
                <span className="text-[10px] font-bold">Store</span>
            </button>

            {/* Fab button with submenu */}
            <div className="relative mx-1" ref={menuRef}>
                {isMenuOpen && (
                    <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col overflow-hidden w-48 z-50">
                        <button onClick={() => handleServiceClick('upload-prescription')} className="flex items-center gap-3 px-4 py-3 hover:bg-sky-50 text-left border-b border-gray-50 transition-colors">
                            <i className="fas fa-file-prescription text-sky-500 text-lg w-5 text-center"></i>
                            <span className="text-sm font-bold text-gray-700">Upload Rx</span>
                        </button>
                        <button onClick={() => handleServiceClick('labs')} className="flex items-center gap-3 px-4 py-3 hover:bg-emerald-50 text-left border-b border-gray-50 transition-colors">
                            <i className="fas fa-flask text-emerald-500 text-lg w-5 text-center"></i>
                            <span className="text-sm font-bold text-gray-700">Lab Tests</span>
                        </button>
                        <button onClick={() => handleServiceClick('health-insurance')} className="flex items-center gap-3 px-4 py-3 hover:bg-red-50 text-left transition-colors">
                            <i className="fas fa-heartbeat text-red-500 text-lg w-5 text-center"></i>
                            <span className="text-sm font-bold text-gray-700">Insurance</span>
                        </button>
                    </div>
                )}
                <button 
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className={`flex flex-col items-center justify-center text-white w-12 h-12 rounded-full -mt-8 shadow-lg border-4 border-white transition-all active:scale-95 ${isMenuOpen ? 'bg-sky-600 rotate-45' : 'bg-emerald-600'}`}
                >
                    <i className="fas fa-plus text-xl transition-transform duration-300"></i>
                </button>
            </div>

            <button 
                onClick={() => showPage('orders')}
                className={`flex flex-col items-center gap-1 ${activePage === 'orders' ? 'text-amber-600 scale-110 transition-transform' : 'text-amber-400 hover:text-amber-500'}`}
            >
                <i className="fas fa-clipboard-list text-lg"></i>
                <span className="text-[10px] font-bold">Orders</span>
            </button>

            <button 
                onClick={() => showPage(isAuthenticated ? 'profile' : 'login')}
                className={`flex flex-col items-center gap-1 ${(activePage === 'login' || activePage === 'profile') ? 'text-rose-600 scale-110 transition-transform' : 'text-rose-400 hover:text-rose-500'}`}
            >
                <i className={`fas ${isAuthenticated ? 'fa-user-circle' : 'fa-user'} text-lg`}></i>
                <span className="text-[10px] font-bold">{isAuthenticated ? 'Profile' : 'Login'}</span>
            </button>
        </nav>
    );
};

export default BottomNav;
